import { User } from 'oidc-client';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Permissions } from '../shared/models/permissions.enum';
import { AuthService } from './AuthService';

export const useRequireAuth = (props: RouteComponentProps, requiredPermissions: Permissions[]) => {
  const [state, setState] = useState<{
    isAuthenticated: boolean | null;
    isLoading: boolean;
    hasPermission: boolean | null;
  }>({
    isAuthenticated: false,
    isLoading: true,
    hasPermission: false
  });

  useEffect(() => {
    AuthService.getUser()
      .then(getUserHandle)
      .catch(() => {
        setState({ ...state, isLoading: false });
      });
  }, []);

  const getUserHandle = (user: User | null) => {
    const isAuthenticated = user && user.expires_at > Date.now() / 1000;
    const permissions = requiredPermissions ? requiredPermissions.map(x => x.toString()) : [];
    const requeredPermissions =
      permissions.length > 0 ? permissions : [Permissions.StitchingTool_Admin.toString(), Permissions.StitchingTool_General.toString()];
    const hasPermission = user && user.profile && requeredPermissions.some(x => [...user.profile.permission].indexOf(x) !== -1);

    setState({
      isAuthenticated: isAuthenticated,
      isLoading: false,
      hasPermission: hasPermission
    });
  };

  const { isAuthenticated, isLoading, hasPermission } = state;
  const { location, history } = props;

  if (isLoading) {
    return;
  }

  if (!isAuthenticated) {
    history.push('/login', { from: location.pathname });
    return;
  }

  if (!hasPermission) {
    history.push('/not-authorized', { from: location.pathname });
    return;
  }

  return true;
};
